module.exports = __webpack_public_path__ + "img/The Utility of E-Prescribing System in Malaysia.2c360594.jpg";